import React from "react";
import styles from "../styles/ReviewsAndRating.module.scss";
import ReviewLanding from "../components/ReviewRating/ReviewLanding/ReviewLanding";
import CustomerFeedback from "../components/ReviewRating/CustomerFeedback/CustomerFeedback";
import CustomerRating from "../components/ReviewRating/CustomerRating/CustomerRating";
import AnalyzeCustomer from "../components/ReviewRating/AnalyzeCustomer/AnalyzeCustomer";
import CustomerPainPoint from "../components/ReviewRating/CustomerPainPoint/CustomerPainPoint";
import ListingOptimize from "../components/ReviewRating/ListingOptimize/ListingOptimize";
import BookDemo from "../components/ReviewRating/BookDemo/BookDemo";
import Head from "next/head";

function reviewsAndRatings() {
  return (
    <>
      <Head>
        <title>Trend Analyzer | Socommerz</title>
        <meta name="title" content="Trend Analyzer | Socommerz" />
        <meta
          name="description"
          content="Stay ahead of the market with our AI-driven trend analyzer. Identify emerging trends, forecast consumer behavior, and drive business growth with real-time data insights and predictive analytics."
        />
        <meta
          name="keywords"
          content="Market trend analysis,
Consumer behavior trends,
AI-powered trend forecasting,
Trend insights,
Data-driven trend detection,
Predictive trend analytics,
Trend visualization tools,
Real-time trend monitoring,
Market insights platform,
Emerging market trends"
        />
        <meta name="robots" content="index,follow" />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.socommerz.com/trend-analyzer/"
        />
        <meta property="og:title" content="Trend Analyzer | Socommerz" />
        <meta
          property="og:description"
          content="Stay ahead of the market with our AI-driven trend analyzer. Identify emerging trends, forecast consumer behavior, and drive business growth with real-time data insights and predictive analytics."
        />
        <link
          rel="canonical"
          href="https://www.socommerz.com/trend-analyzer/"
        />
        <link
          rel="alternate"
          href="https://www.socommerz.com/trend-analyzer/"
          hrefLang="en-in"
        />
        <meta
          property="twitter:url"
          content="https://www.socommerz.com/trend-analyzer/"
        />
        <meta property="twitter:title" content="Trend Analyzer | Socommerz" />
        <meta
          property="twitter:description"
          content="Stay ahead of the market with our AI-driven trend analyzer. Identify emerging trends, forecast consumer behavior, and drive business growth with real-time data insights and predictive analytics."
        />
      </Head>
      <main>
        <div className={styles["reviews-and-rating-wrapper"]}>
          <ReviewLanding />
          <AnalyzeCustomer
            title="Semantic Data Analysis of Brand, CPG, Social and Product Reviews for Trend Analysis."
            image="/reviewrating/ReviewDashboard.png"
          />
          <CustomerFeedback />
          <CustomerRating />
          <AnalyzeCustomer
            title="Analyzing Customer Reviews & Shopper Sentiment for eTail Growth"
            image="/reviewrating/Customer-Ratings.png"
          />
          <CustomerPainPoint />
          <ListingOptimize />
          <BookDemo />
        </div>
      </main>
    </>
  );
}

export default reviewsAndRatings;
